<template>
  <div>
    <div>
      <div v-if="weekday" class="meal_cont">
        <meal-type-nav url="/breakfast" title="breakfast" :status="breakfast_status" rkey="breakfast"/>
        <meal-type-nav url="/lunch" title="lunch" :status="lunch_status" rkey="lunch"/>
        <meal-type-nav url="/dinner" title="dinner" :status="dinner_status" rkey="dinner"/>
      </div>
      <div v-else class="meal_cont">
        <meal-type-nav url="/brunch" title="brunch" :status="brunch_status" rkey="brunch"/>
        <meal-type-nav url="/supper" title="supper" :status="supper_status" rkey="supper"/>
      </div>
    </div>
    <router-view class="contents" :key="$route.fullPath"/>
  </div>
</template>

<script>
import MealTypeNav from  '@/components/MealTypeNav.vue';
import { mapState } from 'vuex'
import { fb_auth, fb_users } from '../firebase';

export default {
  name: 'Orders',
  components: {
    MealTypeNav,
  },
  data() {
    return {
      stop: false
    }
  },
  async mounted () {
    await this.checkApproved();
    if (this.stop) {
      console.log('stop: ',this.stop)
    }
    await this.$store.dispatch('getConfig');
    await this.$store.dispatch('setMeals');
    await this.$store.dispatch('getOrders');

    if (!this.stop) {
      // route user accounting to time of day and meal windows
      if (this.weekday) {
        console.log('weekday route')
        if (this.orders.breakfast.open) {
          this.$router.push('/breakfast')
        } else if (this.orders.lunch.open) {
          this.$router.push('/lunch')
        } else if (this.orders.dinner.open) {
          this.$router.push('/dinner')
        }
       } else {
         console.log('weekend route')
        if (this.orders.brunch.open) {
          this.$router.push('/brunch')
        } else  if (this.orders.supper.open) {
          this.$router.push('/supper')
        } else if (this.nomeal) {
          console.log('no meal routing')
          this.$router.push('/nomeal')
        }
       }
    }
  },
  methods: {
    async checkApproved() {
      let doc = await fb_users.doc(fb_auth.currentUser.uid).get();
      let user = doc.data()
      if (!user.approved) {
        console.log('not approved')
        this.stop = true;
        this.$router.push('/awaitingapproval')
      }
    },
  },
  computed: {
    ...mapState([
      'weekday',
      'orders',
      'nomeal',
    ]),
    breakfast_status() {
      return this.orders.breakfast.status;
    },
    lunch_status() {
      return this.orders.lunch.status;
    },
    dinner_status() {
      return this.orders.dinner.status;
    },
    brunch_status() {
      return this.orders.brunch.status;
    },
    supper_status() {
      return this.orders.supper.status;
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/theme.scss';

.meal_cont {
  display: flex;
  justify-content: space-evenly;
  padding: 10px 0px;
  background: $primary;
}

.contents {
  position: absolute;
  top: 169px;
  width: 100%;
  height: calc(100% - 169px);
  overflow-y: scroll;
}
</style>